import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useLetterFormatData } from '@/composables/format-edit/useLetterFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'LetterCompanyCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useLetterFormatData()

const staffNameError = computed(() => {
  const name = formatData.staff_name || ''
  return name.indexOf('さま') >= 0 || name.indexOf('様') >= 0
})

return { __sfc: true,formatData, staffNameError }
}

})